<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> آمار تجهیزات به تفکیک تقسیمات سیاسی </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- استان -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> استان </label>

            <select class="form-select p-2" formControlName="strState" (change)="getProvince()">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_State" [value]="item.strState">

                    {{ item.strState }}

                </option>

            </select>

        </div>

        <!-- شهرستان -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> شهرستان </label>

            <select class="form-select p-2" formControlName="strTownship" (change)="getSection()">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Province" [value]="item.strTownship">

                    {{ item.strTownship }}

                </option>

            </select>

        </div>
        
        <!-- بخش -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> بخش </label>

            <select class="form-select p-2" formControlName="strSection" (change)="getDehestan()">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Section" [value]="item.strSection">

                    {{ item.strSection }}

                </option>

            </select>

        </div>
        
        <!-- دهستان -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> دهستان </label>

            <select class="form-select p-2" formControlName="strDehestan">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Dehestan " [value]="item.strDehestan">

                    {{ item.strDehestan }}

                </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()"> جستجو </button>

        </div>
        
        <!-- گزارش سرجمع -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-warning w-100" (click)="search_Total()"> گزارش سرجمع </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')"> 

                خروجی اکسل
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2" >

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center"> عملیات </th>
    
                        <th class="text-center"> کد دهیاری </th>
                        
                        <th class="text-center"> استان  </th>

                        <th class="text-center"> شهرستان </th>

                        <th class="text-center"> بخش </th>
                
                        <th class="text-center"> دهستان </th>
        
                        <th class="text-center"> آبادی </th>

                        <th class="text-center"> نوع خودرو </th>

                        <th class="text-center"> نام خودرو </th>

                        <th class="text-center"> پلاک </th>

                        <th class="text-center"> وضعیت </th>
                        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <i class="fa fa-eye fa-lg pointer" aria-hidden="true" (click)="openCar(item)"></i>
                            
                        </td>

                        <td [innerHTML]="highlightText(item.strDehyarCode,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strState,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strTownship,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strSection,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strDehestan,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strAbadi,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobileType_strComment,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobileDomain_strComment,searchTerm.value) | faNum"> </td>

                        <td> {{ item.strVehicleNo | faNum }} </td>

                        <td>  </td>

                    </tr>

                </tbody>
    
            </table>
    
        </div>

    </div>

</main>